import { Redirect } from 'react-router-dom';

import WeeklyReportTable from '../../components/WeeklyReportTable/WeeklyReportTable';
import { checkRol } from '../../security';
import { inspector } from '../../security/constantsRols';

const InspectorWeeklyWorkReport = () => {
  const isInspector = checkRol(inspector);

  if (!isInspector) return <Redirect to="/" />;

  return <WeeklyReportTable isInspector />;
};

export default InspectorWeeklyWorkReport;
